'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorTemplateBody = require('./ErrorTemplateBody');

var _ErrorTemplateBody2 = _interopRequireDefault(_ErrorTemplateBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Forbidden403Page = _react2.default.forwardRef(function (props, ref) {
    var edsContext = props.edsContext;

    var errorTitle = edsContext.formatMessage('component.ErrorPage.403');
    var errorMessage = edsContext.formatMessage('component.ErrorPage.403.message');
    var goBackText = edsContext.formatMessage('component.ErrorPage.goBackText');

    return _react2.default.createElement(_ErrorTemplateBody2.default, Object.assign({
        largeIllustrationName: '403.png',
        errorTitle: errorTitle,
        errorMessage: errorMessage,
        text: goBackText,
        hasAction: true
    }, props, {
        ref: ref
    }));
});

Forbidden403Page.propTypes = {
    edsContext: _propTypes2.default.object
};

exports.default = Forbidden403Page;